/** True when the string looks like an HTML fragment (opening or closing tag). */
export const looksLikeHtml = (value: string): boolean => /<\/?[a-z][\s\S]*>/i.test(value.trim());
